// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getProductWarranties} from '../../shared/repositories';

export const updateWarranties = pin =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getProductWarranties(pin);

            dispatch({
                payload,
                property: 'warranties',
                type: actions.UPDATE_PRODUCT_WARRANTIES_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/warranties.js